import { QuestionnaireAttachmentMeta } from "../hooks/attachment";

/**
 * Merges attachment metadata from backend (existingMeta) with pending metadata (size and confirmed_at from newly uploaded files).
 * For new uploads without backend metadata yet, fallback is used to satisfy the type requirement.
 */
export const mergeAttachmentMeta = (
  existingMeta?: QuestionnaireAttachmentMeta,
  pendingMeta?: { size: string; confirmed_at?: string | null },
  fallback?: { filename: string; s3Key: string },
): QuestionnaireAttachmentMeta | undefined => {
  if (!pendingMeta) return existingMeta;

  const base = existingMeta || fallback;
  if (!base) return undefined;

  return {
    ...base,
    size: pendingMeta.size,
    confirmed_at: pendingMeta.confirmed_at ?? existingMeta?.confirmed_at,
  };
};
